import i18next from 'i18next';
import { toResolverResult } from '@famly/vet_form-validators';
/**
 * Validates the login form.
 *
 * @param values the current form values
 * @returns the validated values, or the collected field errors when the password is missing
 */
export const loginFormResolver = values => {
    const errors = {};
    if (!values.password) {
        errors.password = { type: 'required', message: i18next.t($ => $.required) };
    }
    return toResolverResult(values, errors);
};
